export default __webpack_public_path__ + "e78b1e06c8169ab27e3ec80683a17380.png";